export class MyBoardView {
  createArmyList: boolean;
  formatArmyList: boolean;
  createArsenalArmy: boolean;
  createForlder: boolean;
  createContest: boolean;

  constructor(params: MyBoardViewParams) {
    this.createArmyList = params.createArmyList;
    this.formatArmyList = params.formatArmyList;
    this.createArsenalArmy = params.createArsenalArmy;
    this.createForlder = params.createForlder;
    this.createContest = params.createContest;
  }
}

export type MyBoardViewParams = {
  createArmyList: boolean;
  formatArmyList: boolean;
  createArsenalArmy: boolean;
  createForlder: boolean;
  createContest: boolean;
};
